import { typeSelectors } from "../../../definition/types";
import { itemUtils } from "../..";
import itemSelectors from "../../selectors";

export default (state, obj, superId = null) => {
  //null is always a valid superId
  if (superId === null) {
    return true;
  }
  if (superId === obj.id || itemUtils.isAncestorOfItem(itemSelectors.getItemsById(state), obj.id, superId)) {
    return false;
  }
  const superType = itemSelectors.getItemsById(state).get(superId).type;
  return typeSelectors.doesTypeHaveSuperType(state, obj.type, superType);
};
